@if (imageUrl() && !imageNotFound) {
  <img [src]="imageUrl()" alt="" (error)="handleImageNotFound($event)" (load)="resetImageSource()" />
} @else {
  <odx-icon name="picture" [ngStyle]="{ 'font-size': iconSize() }"></odx-icon>
}
